/**
 * Directive to remove an element based on the previously loaded page
 * e.g.
 * <div x-target-referrer="/collections/all"></div>
 */

export default (el, {expression}) => {
  if (!expression) return;

  if (document.referrer.indexOf(expression) === -1 && !window.Shopify.designMode) {
    el.parentNode.removeChild(el);
  }
};
